



















































































































































import { Component, Vue } from 'vue-property-decorator';
import * as amplitude from 'amplitude-js';
import BaseLayout from '@/layouts/BaseLayout.vue';
import { clientsModule, subscriptionModule } from '@/store';

@Component({
  name: 'info-page',
  components: {
    BaseLayout,
  },
})
export default class Catalog extends Vue {
  created() {
    subscriptionModule.fetchSubscriptions(Number(this.$route.params.clientId));
    clientsModule.fetchInfo(Number(this.$route.params.clientId));

    clientsModule.fetchStylists();
    amplitude.getInstance().logEvent('Открыта страница пользователя', { clientId: Number(this.$route.params.clientId) });
  }

  get subscriptions() {
    return subscriptionModule.list;
  }

  get subscription() {
    return this.subscriptions[this.subscriptions.length - 1];
  }

  get client() {
    return clientsModule.model;
  }

  get stylist() {
    return clientsModule.stylists
      .find(stylist => Number(stylist.id) === Number(this.client?.stylistId));
  }

  get clientInfo() {
    return clientsModule.info;
  }

  get stepFormLink() {
    return this.client ? `https://u014798.stepform.io/jpm9mP6?userId=${this.client.id}` : '';
  }

  copyLink() {
    if (this.client?.id != null) {
      navigator.clipboard.writeText(this.stepFormLink).then(() => {
        this.$notify({
          title: 'Ссылка на анкету скопирована',
          message: 'Вставьте в необходимом месте',
        });
      });
    }
  }
}
